import type { AgentOverrideMetadata, TypedAgentOverride } from './tools.types';

interface ResolveEffectiveAgentMetadataOptions {
  organizationId?: string;
  /** Omit for the organization-wide view. */
  workspaceId?: string;
}

/**
 * Collapses the override rows visible to an agent into the metadata that actually applies.
 *
 * Spreads the layers rather than picking the narrowest one, mirroring how the backend applies
 * them: a workspace row that only overrides a name must not hide a category the organization
 * set, or the admin screen would show a different value from the one in effect.
 */
export function resolveEffectiveAgentMetadata(
  overrides: TypedAgentOverride[],
  { organizationId, workspaceId }: ResolveEffectiveAgentMetadataOptions,
): AgentOverrideMetadata {
  const orgOverride =
    overrides.find(
      (override) => override.type === 'ORGANIZATION' && override.organizationId === organizationId,
    ) ?? overrides.find((override) => override.type === 'GLOBAL');

  const workspaceOverride = workspaceId
    ? overrides.find(
        (override) => override.type === 'WORKSPACE' && override.workspaceId === workspaceId,
      )
    : undefined;

  return { ...orgOverride?.metadata, ...workspaceOverride?.metadata };
}
